// NumericMultiNumericQuestion.tsx
import { QuestionConfig, QuestionType } from "../../data/QuestionConfig";
import { Box } from "@mui/material";
import SlidersPage from "../../pages/SlidersPage.tsx";
import { ShoeQuestion } from "./ShoeQuestion.tsx";
import { WeightQuestion } from "./WeightQuestion.tsx";
import { useStoreSelector } from "../../store/hooks";
import { selectCurrentNumericQuestionAnswers } from "../../store/questionnaireSlice";

export default function NumericMultiNumericQuestion({ questionConfig }: { questionConfig: QuestionConfig }) {
    const currentAnswers = useStoreSelector(selectCurrentNumericQuestionAnswers);

    // For shoe size measurement
    if (questionConfig.questionId === "shoe_size_measurement") {
        return (
            <ShoeQuestion questionConfig={questionConfig}/>
        );
    }
    else if (questionConfig.questionId === "weight") {
        return (<WeightQuestion questionConfig={questionConfig}/>);
    }
    // Default multi-numeric questions
    else if (questionConfig.questionType === QuestionType.multiNumeric) {
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    my: 3,
                }}
            >
                <SlidersPage
                    sliderConfigs={questionConfig.inputConfigs!.map((inputConfig) => ({
                        inputId: inputConfig.inputId,
                        label: inputConfig.label,
                        min: inputConfig.min as number,
                        max: inputConfig.max as number,
                        step: inputConfig.step,
                        defaultValue: currentAnswers[inputConfig.inputId] ?? inputConfig.defaultValue,
                        image: inputConfig.image,
                        additionalDisplay: questionConfig.additionalDisplay,
                        minNormal: inputConfig.minNormal ?? (inputConfig.min as number) + (inputConfig.min * 0.15 as number),
                        maxNormal: inputConfig.maxNormal ?? (inputConfig.max as number) - (inputConfig.min * 0.15 as number),
                    }))}
                />
            </Box>
        );
    }
    else if (questionConfig.questionType === QuestionType.numeric) {
        const inputConfig = questionConfig.inputConfigs![0];
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    my: 2,
                }}
            >
                <SlidersPage
                    sliderConfigs={[{
                        inputId: inputConfig.inputId,
                        label: questionConfig.questionHeadline,
                        min: inputConfig.min as number,
                        max: inputConfig.max as number,
                        step: inputConfig.step,
                        defaultValue: currentAnswers[inputConfig.inputId] ?? inputConfig.defaultValue,
                        image: inputConfig.image,
                        additionalDisplay: questionConfig.additionalDisplay,
                        minNormal: inputConfig.minNormal ??  (inputConfig.min as number) + (inputConfig.min * 0.15 as number),
                        maxNormal: inputConfig.maxNormal ?? (inputConfig.max as number) - (inputConfig.min * 0.15 as number),
                    }]}
                />
            </Box>
        );
    }

    return null;
}
